import styled from "styled-components";

export const Wrapper = styled.div`
    /* In your global stylesheet or scoped CSS module */

    .custom-collapse .ant-collapse-header {
        padding: 6px 0px !important; /* Adjust as needed */
    }

    .custom-collapse .ant-collapse-borderless > .ant-collapse-item {
        border-bottom: 1px solid #ffffff;
    }

    .ant-select-multiple.ant-select-lg .ant-select-selection-overflow .ant-select-selection-item-content {
        font-size: 11px;
    }

    .ant-select-selector, .ant-input-number-outlined {
        background: #fff !important;
        color: #5E6278 !important;
        // border-color: #fff !important;    
        min-height: 42px;
    }

    .ant-input-number .ant-input-number-input {
        padding: 9px 11px;
    }

    .ant-select-selection-item {
        font-size: 13px !important;
        font-weight: 500;
    }

    .ant-select-item {
        font-size: .95rem !important;
        font-weight: 500;
    }

    .ant-select .ant-select-arrow {
        height: 22px;
    }

    .ant-select .ant-select-selection-placeholder {
        font-size: 13px !important;
        color: #5E6278 !important;
        font-weight: 500;
    }

    .ant-picker-input input {
        font-size: 13px
    }

    .ant-picker-range {
        border: 1px solid #fff;
    }

    .ant-select-multiple .ant-select-selection-item-content {
        font-size: 12px;
    }

    .apexcharts-legend-group-vertical {
        flex-direction: row;
        display: flex;
    }

    .card-body .ant-collapse {
        background-color: #f9f9f9;
        border-radius: 2px;
        border: none;
    }

    .card-body .ant-collapse-content {
        background-color: #fff;
        padding: 12px 20px;
        border-top: 1px solid #eee;
    }

    .card-body .ant-collapse-item-active .ant-collapse-header {
        background-color: #e6f7ff;
        color: #1677ff;
    }

    .card-body .section-header {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
        padding-left: 4px;
        color: #111;
        border-bottom: 1px solid #ddd;
    }
    
    .metrics-carousel .slick-prev::after,
    .metrics-carousel .slick-next::after {
        content: "" !important;
        display: none !important;
    }

    .metrics-carousel {
        height: 350px;
        overflow: hidden;
        position: relative;
        background: #fff;
    }
    
    .carousel-content-scrollable {
        height: 350px;
        overflow-y: auto !important;
        padding-bottom: 10px;
        background: #fff;
    }
    
    .metrics-carousel .slick-list,
    .metrics-carousel .slick-track,
    .metrics-carousel .slick-slide > div {
        height: 100%;
    }

    .metrics-carousel .slick-slide > div {
        display: flex;
        flex-direction: column;
    }
    
    .responsive-select-container {
        width: 100%;
    }
    
    .custom-select-width {
        width: 100% !important;
        margin-bottom: 10px;
    }
    
    @media (min-width: 768px) {
        .responsive-select-container {
            flex-direction: row;
            width: auto;
        }

        .custom-select-width {
            width: 200px !important;
            margin-bottom: 0;
        }
    }

    /* ── Carousel Header Tabs ─────────────────────────────────────────── */
    .carousel-tabs {
        display: flex;
        gap: 6px;
        width: 100%;
        padding-bottom: 2px;
    }

    .carousel-tab-btn {
        flex: 1;
        padding: 7px 8px;
        border: 1.5px solid #e4e6ef;
        border-radius: 8px;
        background: transparent;
        color: #7e8299;
        font-size: 12.5px;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
        outline: none;
        white-space: nowrap;
        text-align: center;
    }

    .carousel-tab-btn:hover:not(.active) {
        background: #f0f4f8;
        border-color: #314F71;
        color: #314F71;
        transform: translateY(-1px);
    }

    .carousel-tab-btn.active {
        background: #314F71;
        border-color: #314F71;
        color: #ffffff;
        box-shadow: 0 3px 10px rgba(49, 79, 113, 0.35);
    }

    .carousel-tab-btn:focus-visible {
        outline: 3px solid #63CE94;
        outline-offset: 2px;
    }
`